'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PanelGroup = require('react-bootstrap/lib/PanelGroup');

var _PanelGroup2 = _interopRequireDefault(_PanelGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _PanelGroup2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@sketchpixy/rubix/lib/BPanelGroup.js
// module id = 604
// module chunks = 0